import { trackEvent } from "@/utils/omega";

// 公参存储KEY
const KEY_FOR_CommonParams: string = "KFCP";

// 通用请求头
export const CommonHeaders: Map<string, string | number> = new Map();

// 公共参数
export const CommonParams: { [name: string]: any } = {};

// 从session中恢复公参
try {
  const cacheContent: string | null = window.sessionStorage.getItem(KEY_FOR_CommonParams);
  if (cacheContent) {
    Object.assign(CommonParams, JSON.parse(cacheContent));
  }
} catch (e) {
  console.log("获取session公参失败", e);
}

// 设置请求头
export function setHeader(key: string, value: string | number) {
  CommonHeaders.set(key, value);
}

// 设置公参
export function setParam(key: string, value: string | number) {
  try {
    CommonParams[key] = value;
    // 利用session备份公参
    window.sessionStorage.setItem(KEY_FOR_CommonParams, JSON.stringify(CommonParams));
  } catch (e) {
    console.log(e);
  }
}

const loadModule = () => {
  return window.Fusion && window.Fusion.loadModule("SofiBridgeModule");
};

export const checkLogin = (): Promise<boolean> => {
  return new Promise((resolve) => {
    try {
      const module = loadModule();
      if (module && module.sfCheckLogin) {
        module.sfCheckLogin((res: any) => {
          const isLoggedIn = res?.logged === 1;
          if (!isLoggedIn) {
            // 埋点：sfCheckLogin 正常执行，但当前用户未登录。
            trackEvent("tech_sofi_catch_error", {
              source: "urils.requestCommon.checkLogin",
              data: "checkLogin returned false",
            });
          }
          resolve(isLoggedIn);
        });
      } else {
        // 埋点：Fusion 模块或 sfCheckLogin 方法尚不可用。
        trackEvent("tech_sofi_catch_error", {
          source: "urils.requestCommon.checkLogin",
          data: "SofiBridgeModule.sfCheckLogin is unavailable",
        });
        resolve(false);
      }
    } catch (e) {
      // 埋点：调用 sfCheckLogin 时发生同步异常。
      trackEvent("tech_sofi_catch_error", {
        source: "urils.requestCommon.checkLogin",
        data: e instanceof Error ? e.message : JSON.stringify(e),
      });
      resolve(false);
    }
  });
};
